<template>
  <div id="workbench" class="iBusiness-body">
    <audio ref="voice" :src="'./static/audio/newMsg.mp3'" />
    <section class="chat-wrapper">
      <div class="chat-tab">
        <ul class="tab-list js-tab-list">
          <li v-for="(item, index) in session_tab" :key="index" :class="session_tab_active === index ? 'active' : ''" @click="session_tab_active = index">
            {{ item }}
          </li>
        </ul>
        <agent-table v-show="session_tab_active === 0" :curSessionId='this.current_user.sessionId' />
      </div>
      <div v-show="dialogBox" class="chat-content">
        <div class="chat-block" style="height: calc(100% - 56px);">
          <div class="title">
            <div>
              <svg class="icon icon-pcuser" aria-hidden="true">
                <use xlink:href="#iconyonghu" />
              </svg>
              <span>{{ current_user.body.nickname }}</span>
            </div>
            <div class="title-self" v-show="!huihuajieshuFlag">
              <!-- <span>
                <el-tooltip effect="light" content="参与会话" placement="top">
                  <button @click="joinSession" style="margin:0;padding:0;background:none;border:none;line-height:18px;height:18px;display:inline-block;">
                    <svg class="icon" aria-hidden="true">
                      <use xlink:href="#iconhuihuayaoqing" />
                    </svg>
                  </button>
                </el-tooltip>
              </span> -->
              <span>
                <el-tooltip effect="light" content="加入黑名单" placement="top">
                  <button @click="addBlockList" style="margin:0;padding:0;background:none;border:none;line-height:18px;height:18px;display:inline-block;">
                    <svg class="icon" aria-hidden="true">
                      <use xlink:href="#iconheimingdan" />
                    </svg>
                  </button>
                </el-tooltip>
              </span>
              <span>
                <el-tooltip effect="light" content="结束会话" placement="top">
                  <button @click="finishSession" style="margin:0;padding:0;background:none;border:none;line-height:18px;height:18px;display:inline-block;">
                    <svg class="icon" style="color:red" aria-hidden="true">
                      <use xlink:href="#iconjieshuduihua" />
                    </svg>
                  </button>
                </el-tooltip>
              </span>
            </div>
          </div>
          <session-info ref="sessionInfoRef" :curSessionInfo="curSessionInfo" :curJoinAgent="curJoinAgent"></session-info>
          <div v-show="msg_tips_show" @click="toBottom" class="msgTips">
            <i class="el-icon-bottom" />您有新消息
          </div>
          <transition name="fade">
            <div class="wait-block" style="bottom:30px" v-show="this.current_user.userId && this.current_user.body.userNoReplyMsgTime !== '0'">
              客人已等待了<count-timer class="text-danger" ref="waitTimer"></count-timer>
            </div>
          </transition>
          <div class="chat-box" style="height: calc(100% - 159px);">
            <div id="chatNews" ref="list1" class="chat-news pst">
              <div id="loadChatHistories" v-if="loading" style="height:20px" v-loading="loading" element-loading-spinner="el-icon-loading">
              </div>
              <div v-for="(item, index) in current_user.body.chatHistories" :key="current_user.sessionId + (item.cid || item.t) + index" :class="item.d === 'up' ? 'questioner' : 'answerer'" class="block">
                <div v-if="item.d === 'system'" style="text-align:center;color:grey">
                  <p class="time">
                    <template>
                      {{ item.t }}
                    </template>
                  </p>
                  <p>
                    <template>
                      {{ item.msg.content }}
                    </template>
                  </p>
                </div>
                <div v-else>
                  <p class="inform">
                    <template v-if="item.d === 'up'">
                      <span class="username">{{ current_user.body.nickname }}</span>
                      <span>{{ item.t }}</span>
                    </template>
                    <template v-else>
                      <span>{{ item.t }}</span>
                      <span class="username">{{ item.agent.name ? item.agent.name : '客服' }}</span>
                    </template>
                  </p>
                  <div class="news-wrap">
                    <template v-if="item.d === 'up'">
                      <div class="news-avator">
                        <svg class="icon" aria-hidden="true">
                          <use :xlink:href="'#icon'+ (item.d === 'up' ? 'user-head' : 'kefu-head')" />
                        </svg>
                      </div>
                      <div class="news" v-viewer>
                        <p v-html="translateMessage(item.type, item.msg)" />
                      </div>
                    </template>
                    <template v-else>
                      <div class="news" v-viewer>
                        <p v-html="translateMessage(item.type, item.msg)" />
                      </div>
                      <div class="news-avator">
                        <template v-if="item.agent.avatar">
                          <el-avatar :src="resourceDownloadPath + item.agent.avatar"></el-avatar>
                        </template>
                        <template v-else>
                          <svg class="icon" aria-hidden="true">
                            <use :xlink:href="'#iconkefu-head'" />
                          </svg>
                        </template>
                      </div>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <div class="msg_predict">
              <span>{{ this.current_user.msgPredict }}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 黑名单对话框 -->
      <el-dialog width="600px" title="加入黑名单" :visible="addBlacklistItemDialog" :close-on-click-modal="false" @close="closeAddBlacklistItemDialog">
      <el-form ref="addItemForm" size="medium" :model="blacklistForm" label-width="100px">
        <el-form-item label="解禁时间" size="medium" prop="unbanTime">
            <el-date-picker
              v-model="blacklistForm.unbanTime"
              type="datetime"
              placeholder="选择解禁时间"
              align="center"
              prefix-icon="aaa"
              style="width:90%;"
              :picker-options="pickerDisabled"
              >
            </el-date-picker>
        </el-form-item>
        <el-form-item class="text-left" label="封禁原因" prop="banMessage">
          <el-input type="textarea" maxlength="200" rows=4 v-model="blacklistForm.banMessage" style="width:90%;" placeholder="请输入封禁原因"></el-input>
        </el-form-item>
      </el-form>
      <el-row slot="footer" type="flex" justify="center" style="margin-top: -20px">
        <el-button size="medium" @click="closeAddBlacklistItemDialog">取 消</el-button>
        <el-button type="primary" size="medium" @click="addNewBlacklistItem">确 定</el-button>
      </el-row>
    </el-dialog>
      <!-- <div v-show="blankPage" class="blankPage">
        <img src="@/assets/images/page/xiaoi3.png">
      </div> -->
      <iframe v-show="false" src="" name="hide_iframe" width="0" height="0" frameborder="0" scrolling="no" />
    </section>
  </div>
</template>
<script>
import watchUtils from '../../utils/watchUtils'
export default watchUtils
</script>
<style lang="scss">
@import "@/assets/scss/chatlog/history.scss";
</style>
<style lang="scss" scoped>
.blankPage {
  position: relative;
  -webkit-box-flex: 1;
  flex: auto;
  border-right: 1px solid #d8dbde;
  text-align: center;
  padding-top: 15vh;
  opacity: 0.1;
  img {
    box-shadow: 2px 2px 3px #fff;
  }
}
.badge-chat {
  float: right;
  margin-top: 7px;
  margin-left: 5px;
}

.widgets-container {
  /* 设置滚动槽样式 */
  ::-webkit-scrollbar {
    width: 2px;
    background-color: #d8d8d8;
  }
  ::-webkit-scrollbar-track {
    border-radius: 10px;
  }
  ::-webkit-scrollbar-thumb {
    background-color: #bfc1c4;
  }
}
.msgTips {
  position: absolute;
  cursor: pointer;
  right: 10px;
  bottom: 170px;
  z-index: 3;
  width: 75px;
  padding: 5px 0;
  // height: 26px;
  // line-height: 26px;
  text-align: center;
  // background-color: $body-bg;
  color: #8796a6;
  border-radius: 4px 0 4px 0;
  box-shadow: -2px 0 10px #ccc;

  transition: left 0.1s;
}
.wait-block {
  position: absolute;
  z-index: 3;
  bottom: 180px;
  left: 50%;
  margin-left: -120px;
  width: 240px;
  height: 26px;
  border-radius: 13px;
  line-height: 26px;
  overflow: hidden;
  text-align: center;
  font-size: 12px;
  color: #666;
  background-color: #f0f0f0;
}
.robot_btn {
  padding: 3px;
  margin-left: 5px;
  background-color: #8cc5ff;
  color: #fff;
  cursor: pointer;
}
.offline-disable {
  pointer-events: none;
}
.msg_predict {
  position: absolute;
  color: #808695;
  text-align: left;
  padding: 2px 2px 2px 13px;
  bottom: 160px;
  font-size: 12px;
}
.quick_reply_item {
  &:hover {
    cursor: pointer;
    background-color: rgb(217, 236, 255);
  }
}
.radio-group1 {
  max-width: 100%;
  padding-right: 12px;
  .el-radio,
  .el-radio__input {
    line-height: 1.6;
  }
  .el-radio {
    width: 100%;
  }
  ::v-deep .el-radio__label {
    overflow: hidden;
    text-overflow: ellipsis;
    width: calc(100% - 15px);
    display: inline-block;
    vertical-align: middle;
    padding-left: 5px;
  }
}
.menu-number.el-dropdown-menu {
  width: 264px;
  padding: 0;
  .el-table {
    &:before {
      width: 0;
    }
    ::v-deep th,
    ::v-deep td {
      background-color: #fff !important;
      /*text-align: center;*/
      border-bottom: none !important;
      padding: 4px 15px !important;
      color: #666;
      font-size: 12px;
    }
    ::v-deep td:last-child {
      color: #111 !important;
    }
    ::v-deep .cell {
      width: auto !important;
    }
    ::v-deep .el-table__body-wrapper {
      max-height: 130px;
      overflow-y: auto;
      &::-webkit-scrollbar {
        width: 4px;
        height: 4px;
      }
      &::-webkit-scrollbar-thumb {
        background-color: #ebebeb;
        border-radius: 2px;
      }
    }
  }
}
</style>
<style lang="scss">
.widgets-container {
  .el-tag {
    color: #337eff;
  }
  .el-tabs__item {
    color: #333333;
  }
  .el-tabs__item:hover,
  .el-tabs__item.is-active {
    color: #337eff;
  }
  .el-tabs__active-bar {
    height: 2px;
    background-color: #337eff !important;
  }
}
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
.demo-table-expand .el-form-item {
  margin-left: 20px;
  margin-bottom: 0;
  width: 400px;
}
.el-avatar > img {
  width: 100%;
  object-fit: fill !important; // 填充则改 fill
}
</style>
<style scoped>
.iBusiness-body {
  padding-top: 0px;
}
.iBusiness-wrapper .iBusiness-body .chat-wrapper .chat-tab {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -ms-flex-direction: column;
  flex-direction: column;
  width: 320px;
  -webkit-box-flex: 0;
  -ms-flex: 0 0 320px;
  flex: 0 0 320px;
  border-right: 1px solid #d6d9e4;
}
.queuing-libox .el-table .el-table__body-wrapper td:last-child {
  display: table-cell;
}

/* 客户等待时长过渡 */
.fade-enter-active,
.fade-enter {
  opacity: 0;
  transition: all 0.5s ease;
}
.fade-leave-active, .fade-leave-to /* .fade-leave-active, 2.1.8 版本以下 */ {
  transition: 0s ease;
}
</style>
